import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, Fragment, useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {RootState} from "../../redux/store";

function AuthorityModify() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const location = useLocation();

    const [adName, setAdName] = useState('');
    const [goodsName, setGoodsName] = useState('');
    const [shoppingUrl, setShoppingUrl] = useState('');
    const [bannerImage, setBannerImage] = useState<File | null>(null);
    const [goodsImage, setGoodsImage] = useState<File | null>(null);
    const [date, setDate] = useState(dayjs());
    const [goodsPrice, setGoodsPrice] = useState('');
    const [goodsDiscPrice, setGoodsDiscPrice] = useState('');

    const [nowBanner, setNowBanner] = useState('');
    const [bannerNew, setBannerNew] = useState<string | null>('');
    const [nowGoods, setNowGoods] = useState('');
    const [goodsNew, setGoodsNew] = useState<string | null>('');

    const currentId = location.state?.id
    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 수정'
        //@ts-ignore
        if (auth.MENUAUTH.AD0000.readAuthorityYn !== "1" && auth.MENUAUTH.AD0000.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        //@ts-ignore
        else if (auth.MENUAUTH.AD0000.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다')
            navigate('/AdvertisingManagement')
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'ad/view', {
                params: { id: currentId },
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAdName(response.data.result[0].adName)
                setGoodsName(response.data.result[0].goodsName)
                setBannerImage(response.data.result[0].bannerImg)
                setGoodsImage(response.data.result[0].goodsImg)
                setShoppingUrl(response.data.result[0].shoppingMallUrl)
                setDate(dayjs(response.data.result[0].adDtm))
                setGoodsPrice(response.data.result[0].goodsPrice)
                setGoodsDiscPrice(response.data.result[0].goodsDiscountPrice)
            })
            const nowBannerImage = async () => {
                try {
                    const resBannerImg = await axios.get( url + 'ad/bannerImage', {
                        params: { id: currentId },
                        responseType: 'arraybuffer',
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    });
                    if (resBannerImg){
                        const base64Banner = arrayBufferToBase64(resBannerImg.data);

                        setNowBanner(`data:image/jpeg;base64,${base64Banner}`)
                    }

                } catch (error) {
                    console.error('이미지를 불러오는데 실패했습니다.', error);
                }
            };

            const nowGoodsImage = async () => {
                try {
                    const resGoodsImg = await axios.get(url + 'ad/goodsImage', {
                        params: { id: currentId },
                        responseType: 'arraybuffer',
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    });
                    if (resGoodsImg) {
                        const base64Goods = arrayBufferToBase64(resGoodsImg.data);

                        setNowGoods(`data:image/jpeg;base64,${base64Goods}`);
                    }
                } catch (error){
                    console.error('이미지를 불러오는데 실패했습니다.', error);
                }
            }

            const arrayBufferToBase64 = (buffer: Iterable<number>) => {
                return btoa(
                    new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            };

            nowBannerImage();
            nowGoodsImage();
        })
    }, [currentId]);

    const today = new Date().toISOString().split('T')[0];

    const handleUpdateAd = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            if (!adName || !goodsName || !shoppingUrl || !goodsPrice || !goodsDiscPrice) {
                alert('내용을 수정할 수는 있지만, 빈 항목은 허용되지 않습니다.')
            } else if (date.format('YYYY-MM-DD') < today){
                alert('현재보다 과거 날짜를 선택할 수 없습니다.')
            }
            else {
                const isAction = window.confirm('수정 하시겠습니까?');
                if (isAction) {
                    try {
                        const formData = new FormData();
                        formData.append('id', currentId);
                        formData.append('adName', adName);
                        formData.append('goodsName', goodsName);
                    if (bannerImage) {
                        formData.append('bannerImg', bannerImage);
                    }
                    if (goodsImage) {
                        formData.append('goodsImg', goodsImage);
                    }
                        formData.append('shoppingMallUrl', shoppingUrl);
                        formData.append('adDtm', date.format('YYYY-MM-DD 23:59:59'));
                        formData.append('goodsPrice', goodsPrice);
                        formData.append('goodsDiscountPrice', goodsDiscPrice);
                        axios.post(url + 'ad/update', formData, {
                            headers: {
                                'Authorization': localStorage.getItem('Authorization')
                            }
                        }).then(() => {
                                alert('광고 수정 완료');
                                navigate('/AdvertisingManagement');
                            }
                        )
                    } catch (e) {
                        alert('광고 등록 실패');
                        console.error(e);
                    }
                }
            }
        })
    };

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까?');
        if (Cancel) {
            navigate(-1);
        }
    }

    const handleAdNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setAdName(e.target.value);
    };

    const handleGdNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        setGoodsName(e.target.value);
    };

    const handleBannerImgChange = (e: ChangeEvent<HTMLInputElement>) => {
        //@ts-ignore
        const file = e.target.files[0];
        if (file) {
            setBannerImage(file);

            const reader = new FileReader();

            reader.onload = () => {
                if (typeof reader.result === 'string') {
                setBannerNew(reader.result);
                } else {
                    setBannerNew(null);
                }
            };

            reader.readAsDataURL(file);
        } else {
            setBannerImage(null);
        }
    };

    const handleGoodsImgChange = (e: ChangeEvent<HTMLInputElement>) => {
        //@ts-ignore
        const file = e.target.files[0];
        if (file) {
            setGoodsImage(file);

            const reader = new FileReader();

            reader.onload = () => {
                if (typeof reader.result === 'string') {
                setGoodsNew(reader.result);
                } else {
                    setBannerNew(null);
                }
            };

            reader.readAsDataURL(file);
        } else {
            setGoodsImage(null);
        }
    }

    const handleUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
        setShoppingUrl(e.target.value);
    };

    const handleDateChange = (newDate: any) => {
        setDate(newDate);
    }

    const handleGoodsPriceChange = (e: ChangeEvent<HTMLInputElement>) => {
        setGoodsPrice(e.target.value);
    }

    const handleGoodsDiscChange = (e: ChangeEvent<HTMLInputElement>) => {
        setGoodsDiscPrice(e.target.value);
    }


    return (
        <div id="wrapper">
            <Sidebar menuCode={"AD0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='광고 수정'/>
                        <Card className="card shadow mb-4">
                            <Card.Body>
                                <p style={{fontSize:'14px',marginBottom:'10px'}} className="before_required">표시는 필수 입력 항목입니다.</p>
                                <Table bordered>
                                    <tbody>
                                    <tr>
                                        <td style={{width: '20%'}} className={styles.tableHead}><p className="after_required">광고명</p></td>
                                        <td style={{width: '100%'}}>
                                            <Form.Control type="text" placeholder="광고명을 적어주세요" name="adName"
                                                          value={adName} onChange={handleAdNameChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><p className="after_required">상품명</p></td>
                                        <td><Form.Control type="text" placeholder="상품명을 적어주세요" name="goodsName"
                                                          value={goodsName} onChange={handleGdNameChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={styles.tableHead}><p className="after_required">URL</p></td>
                                        <td>
                                            <Form.Control type="text"
                                                          placeholder="URL을 입력해주세요" name="shoppingMallUrl"
                                                          value={shoppingUrl} onChange={handleUrlChange}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"20%", verticalAlign: "middle"}} className={styles.tableHead}><p>배너 이미지</p></td>
                                        <td style={{width:"100%", display:"flex", alignItems:"center"}}>
                                            <Form.Control type="file" accept=".jpg, .png, .jpeg"
                                                          name="bannerImg" onChange={handleBannerImgChange}/>
                                            {
                                                bannerImage
                                                    ? bannerNew && <p style={{display:"flex", alignItems:"center"}}>수정된 이미지:<img src={bannerNew} alt="이미지 없음" style={{marginLeft:"10px", maxWidth: "200px", maxHeight: "200px"}} /></p>
                                                    : nowBanner && <p style={{display:"flex", alignItems:"center"}}>기존 이미지:<img src={nowBanner} alt="이미지 없음" style={{marginLeft:"10px", maxWidth: "200px", maxHeight: "200px"}} /></p>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"20%", verticalAlign: "middle"}} className={styles.tableHead}><p>상품 이미지</p></td>
                                        <td style={{width:"100%", display:"flex", alignItems:"center"}}>
                                            <Form.Control type="file" accept=".jpg, .png, .jpeg"
                                                          name="goodsImg" onChange={handleGoodsImgChange}/>
                                            {
                                                goodsImage
                                                ? goodsNew && <p style={{display:"flex", alignItems:"center"}}>수정된 이미지:<img src={goodsNew} alt="이미지 없음" style={{marginLeft:"10px", maxWidth: "200px", maxHeight: "150px"}} /></p>
                                                : nowGoods && <p style={{display:"flex", alignItems:"center"}}>기존 이미지:<img src={nowGoods} alt="이미지 없음" style={{marginLeft:"10px", maxWidth: "200px", maxHeight: "150px"}} /></p>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"20%"}} className={styles.tableHead}><p className="after_required">광고 기간</p></td>
                                        <td style={{width:"100%"}}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
                                                <DemoContainer components={['DatePicker']}>
                                                    <DatePicker
                                                        label="광고 기간 선택"
                                                        format="YYYY-MM-DD"
                                                        slotProps={{
                                                            textField: {
                                                                size: 'small'
                                                            }
                                                        }}
                                                        name = "adDtm"
                                                        value={date}
                                                        onChange={handleDateChange}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"20%"}} className={styles.tableHead}><p className="after_required">상품 원가</p></td>
                                        <td style={{width:"100%"}}>
                                            <Form.Control type="text" placeholder="상품 원가" value={goodsPrice}
                                                          name="goodsPrice" onChange={handleGoodsPriceChange}/></td>
                                    </tr>
                                    <tr>
                                        <td style={{width:"20%"}} className={styles.tableHead}><p className="after_required">상품 할인가</p></td>
                                        <td style={{width:"100%"}}>
                                            <Form.Control type="text" placeholder="상품 할인가" name="goodsDiscountPrice"
                                                          value={goodsDiscPrice} onChange={handleGoodsDiscChange}/></td>
                                    </tr>



                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary" onClick={handleUpdateAd} type="submit">저장</button>
                                    <button className="btn btn-secondary" onClick={handleModifyCancel}>취소</button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default AuthorityModify;